import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Portfolio from './components/Portfolio/Portfolio';
import Work from './components/Work/Work';
import Landing from './components/Landing/Landing';
import Photography from './components/Photography/Photography';
import PacerScoutProject from './views/pacerScout/pacerScout';
import PacerFinancingProject from './views/pacerFinancing/pacerFinancing';
import PacerBidrProject from './views/pacerBidr/pacerBidr';
import YoutubeSummarizerProject from './views/youtubeSummarizer/youtubeSummarizer';
import KickTheTiresProject from './views/kickTheTires/kickTheTires';
import OswProject from './views/osw/osw';
const App: React.FC = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/work" element={<Work />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio/pacer-scout" element={<PacerScoutProject />} />
        <Route path="/portfolio/pacer-consumer-financing" element={<PacerFinancingProject />} />
        <Route path="/portfolio/pacer-bidr-integration" element={<PacerBidrProject />} />
        <Route path="/portfolio/youtube-summarizer" element={<YoutubeSummarizerProject />} />
        <Route path="/portfolio/kick-the-tires" element={<KickTheTiresProject />} />
        <Route path="/portfolio/osw" element={<OswProject />} />
        <Route path="/photography" element={<Photography />} />
      </Routes>
    </>
  );
};

export default App;
